import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchCustomizedTripsDtlcoverinclall } from "../services/CustomizedTripsDtlcoverinclall";

const CustomizedTripsDtlcoverinclall = () => {
  const { id } = useParams();
  const [CustomizedTripsDtl, setCustomizedTripsDtl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchCustomizedTripsDtlcoverinclall(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setCustomizedTripsDtl(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!CustomizedTripsDtl) return <div>No data found</div>;

  // Split covered_place into array of inclusion
  const inclusion = CustomizedTripsDtl.inclusion
    ? CustomizedTripsDtl.inclusion
        .split("@@")
        .map((place) => place.trim())
        .filter(Boolean)
    : [];

  // Split covered_place into array of exclusion
  const exclusion = CustomizedTripsDtl.exclusion
    ? CustomizedTripsDtl.exclusion
        .split("@@")
        .map((exclusiondata) => exclusiondata.trim())
        .filter(Boolean)
    : [];

  // Split covered_place into array of activity
  const activity = CustomizedTripsDtl.activity
    ? CustomizedTripsDtl.activity
        .split("@@")
        .map((activitydata) => activitydata.trim())
        .filter(Boolean)
    : [];

  return (
    
     <>
     {/* What's Included */}
    <section id="included" className="scroll-mt-28">
      <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div className="p-4 md:p-6">
          <h2 className="text-lg md:text-2xl font-bold text-slate-900 mb-4 md:mb-6">
            What's Included
          </h2>
          <div className="space-y-3 md:space-y-4">

          {inclusion.map((place, index) => (
            <div key={index} className="flex items-start gap-3 md:gap-4">
              <div className="flex-shrink-0 mt-1">
                <div className="h-8 w-8 md:h-10 md:w-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check-circle h-5 w-5 md:h-6 md:w-6 text-primary flex-shrink-0 mt-0.5"
                  >
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                    <path d="m9 11 3 3L22 4" />
                  </svg>
                </div>
              </div>
              <span className="text-sm md:text-base text-slate-700 leading-relaxed">
                 {place}
              </span>
            </div>
          ))}

          </div>

        </div>
      </div>
    </section>

    {/* What's Not Included */}
    <section id="excluded" className="scroll-mt-28">
      <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div className="p-4 md:p-6">
          <h2 className="text-lg md:text-2xl font-bold text-slate-900 mb-4 md:mb-6">
            What's Not Included
          </h2>
          <div className="space-y-3 md:space-y-4">

      {exclusion.map((exclusiondata, index) => (
          <div className="flex items-start gap-3 md:gap-4">
            <div className="flex-shrink-0 mt-1">
              <div className="h-8 w-8 md:h-10 md:w-10 rounded-full bg-red-50 flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-x h-4 w-4 md:h-5 md:w-5 text-red-600"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </div>
            </div>
            <span className="text-sm md:text-base text-slate-700 leading-relaxed">
              {exclusiondata}
            </span>
          </div>
      ))}
        </div>
        </div>
      </div>
    </section>

    {/* Highlights */}
    <section id="highlights" className="scroll-mt-28">
      <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div className="p-4 md:p-6">
          <h2 className="text-lg md:text-2xl font-bold text-slate-900 mb-4 md:mb-6">
            Trip Highlights
          </h2>
          <div className="grid md:grid-cols-2 gap-3 md:gap-4">
            {activity.map((activitydata, index) => (
              <div key={index} className="flex items-start gap-2 md:gap-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-check-circle h-5 w-5 md:h-6 md:w-6 text-primary flex-shrink-0 mt-0.5"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <path d="m9 11 3 3L22 4" />
                </svg>
                <span className="text-sm md:text-base text-slate-700 leading-relaxed">{activitydata}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    

     </>

  );
};

export default CustomizedTripsDtlcoverinclall;
